import { useState } from "react";
import { API } from "../../data/siteData";
import NewsEditor from "./NewsEditor";
import NewsList from "./NewsList";

export default function NewsManager({ articles, onRefresh }) {
  const [editingArticle, setEditingArticle] = useState(null);

  const beginNew = () => {
    setEditingArticle(null);
  };

  const beginEdit = (article) => {
    setEditingArticle(article);
  };

  const archiveArticle = async (article) => {
    if (!window.confirm(`Archive “${article.title}” from public publishing?`)) return;
    await fetch(`${API}/admin/news/${article.article_id}`, { method: "DELETE", credentials: "include" });
    if (editingArticle?.article_id === article.article_id) beginNew();
    await onRefresh();
  };

  return (
    <section className="admin-section content-manager" data-testid="admin-news-manager">
      <div className="admin-section-heading">
        <div><span className="eyebrow">Publishing desk</span><h2>NEWS &amp; UPDATES</h2></div>
      </div>
      <div className="content-manager-grid">
        <NewsList articles={articles} onArchive={archiveArticle} onEdit={beginEdit} onNew={beginNew} />
        <NewsEditor article={editingArticle} onSaved={async () => { beginNew(); await onRefresh(); }} />
      </div>
    </section>
  );
}